export default function BlackProductsSkeleton() {
  return <div className='absolute left-0 top-0 flex h-[237px] gap-2 overflow-hidden lg:h-[336px]' data-sentry-component="BlackProductsSkeleton" data-sentry-source-file="black-products-skeleton.tsx">
            {Array(7).fill(null).map((_, i) => <div key={i} className='h-full w-36 shrink-0 animate-pulse rounded-lg bg-neutral-800 lg:w-[219px]' />)}
        </div>;
}